module.exports = __webpack_public_path__ + "static/media/infoIcon.9d487527.svg";